import * as React from 'react';

function QuestionAndAnswer({ qa, questionsAndAnswersFile }) {
  const [expanded, setExpanded] = React.useState(false);
  const { question, answer, id } = qa;

  const panelId = id ? `${id}-answer` : undefined;

  function handleToggleExpansion() {
    setExpanded(prevExpanded => {
      const nextExpanded = !prevExpanded;

      // When opening, update the URL hash so it becomes question id
      if (nextExpanded && typeof window !== 'undefined' && id) {
        const newUrl = `${window.location.pathname}${window.location.search}#${id}`;
        window.history.replaceState(null, '', newUrl);
      }

      return nextExpanded;
    });
  }

  // On mount, if the current URL hash matches this question id,
  // auto-expand it and scroll into view
  React.useEffect(() => {
    if (typeof window === 'undefined' || !id) return;

    const hash = window.location.hash.replace('#', '');
    if (hash === id) {
      setExpanded(true);
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }, [id]);

  function renderAnswer() {
    if (!expanded) return null;
    return (
      <div className="answer" id={panelId}>
        {answer}
      </div>
    );
  }

  function renderExpandOrCollapseIcon() {
    const buttonClass = questionsAndAnswersFile === 'lessons' ? 'focus-on-dark' : 'focus-on-light';
    const imageLink = expanded ? 'collapse.svg' : 'expand.svg';
    const innerElement = (
      <img
        alt=""
        src={`${window.postbuildEnv.CDN_URL}/images/shared/${imageLink}`}
      />
    );

    // This is purely visual now; the whole outer button is the interactive control
    return (
      <span aria-hidden="true" className={`expand-collapse-button ${buttonClass}`}>
        {innerElement}
      </span>
    );
  }

  return (
    <button
      aria-controls={panelId}
      aria-expanded={expanded}
      className="interactive-wrapper qa-section focus-on-light"
      id={id || ''}
      onClick={handleToggleExpansion}
      type="button"
    >
      <div className="qa">
        <div className="question">
          {question}
        </div>
        {renderAnswer()}
      </div>
      <div>
        {renderExpandOrCollapseIcon()}
      </div>
    </button>
  );
}

export default QuestionAndAnswer;


